const toAcronym = (string) => {
  if (!string) {
    return '';
  }
  return string
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase();
};

/**
 * Renders a bank account number fragment (typically last four digits from the API) as ****1234.
 */
const formatBankAccountLastFourDisplay = (accountNumberFragment) => {
  if (accountNumberFragment == null || accountNumberFragment === '') {
    return '-';
  }

  const digits = String(accountNumberFragment).replace(/\D/g, '');
  const lastFour = digits.slice(-4);

  if (!lastFour) {
    return '-';
  }

  return `****${lastFour}`;
};

const toSentenceCase = (string = '') => {
  // https://github.com/huynhsamha/js-convert-case/blob/master/src/modules/js-sentencecase/index.ts
  if (!string) return '';

  const textcase = String(string)
    .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
    .replace(/([a-z])([A-Z])/g, (m, a, b) => `${a}_${b.toLowerCase()}`)
    .replace(/[^A-Za-z0-9]+|_+/g, ' ')
    .toLowerCase();

  return textcase.charAt(0).toUpperCase() + textcase.slice(1);
};

export { formatBankAccountLastFourDisplay, toAcronym, toSentenceCase };
